const switchAccountDetails = (state = null, action) => {
    if (action.type === "SET_SWITCH_ACCOUNT_DETAILS") {
        return action.payload;
    } else {
        return state;
    }
};

export default switchAccountDetails;
